/**
 * Message display type , used to alter the display of the notification
 */
export enum NotificationCenterMessageType {
  Toast = 1,
  // Full screen not used currently
  // Fullscreen = 2,
  PersistentToast = 3,
  Alert = 4,
}

/**
 * Action type of the notification, used to change the action of the notification
 */
export enum NotificationCenterActionType {
  /** No link */
  NoAction = 1,
  /** Internal link built via notification center mappings */
  InternalLink = 2,
  /** Action is to be used as the full url */
  ExternalLink = 3,
}
